import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Club_PageMenu_ApiEnum } from './ClubDetailConfigApiInterface';

export enum Config_ClubAccountIssuedDocument_ActionsMenu_ApiEnum {
    'print_document' = 'print_document',
    'mark_document_as_final' = 'mark_document_as_final',
}

export enum Config_ClubAccountIssuedDocument_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'results' = 'results',
}

export enum Config_ClubAccountIssuedDocument_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
}

export enum Config_ClubAccountIssuedDocument_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_ClubAccountIssuedDocument_ApiInterface
    extends ConfigDataInterface<
        Config_ClubAccountIssuedDocument_Modules_ApiEnum,
        Config_ClubAccountIssuedDocument_ActionsMenu_ApiEnum,
        Config_ClubAccountIssuedDocument_ActionsOther_ApiEnum,
        Config_Club_PageMenu_ApiEnum,
        Config_ClubAccountIssuedDocument_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
